// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3a5AM","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2mb1V"};